<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="480px"
    @close="$router.replace('/data/shops/chains')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="shopChain"
      :rules="rules"
      ref="shopChainForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input v-model="shopChain.name" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/shops/chains')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="store"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'shopChainId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        shopChain: {},
        rules: {
          name: [
            { required: true, message: 'Név megadása kötelező', trigger: 'change'}
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új üzletlánc';
        } else if (this.type === 'update') {
          return 'Üzletlánc módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    methods: {
      async store() {
        this.$refs['shopChainForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('shopChain/create', this.shopChain);
              } else if (this.type === 'update') {
                await this.$store.dispatch('shopChain/update', this.shopChain);
              }
              this.$store.dispatch('shopChain/fetchAllWithPagination');
              this.buttonLoading = false;
              this.$router.replace('/data/shops/chains');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
    },
    async mounted() {
      this.loading = true;
        if (this.shopChainId) {
          this.shopChain = await this.$store.dispatch('shopChain/fetch', this.shopChainId);
        }
        this.loading = false;
    }
  };
</script>
